import ApiFactory from '@/factories/ApiFactory';
import { prepAutocompleteData, serialize } from '@/services/UtilityService';

const get = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/app/blocks?${query}`).then(({ data }) => {
			resolve(prepAutocompleteData(data.data, 'categoryName', 'categoryID'));
		}, reject);
	});
};

const details = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`restaurant/v2/restaurants/categories/${id}`).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const create = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`restaurant/v2/restaurants/categories`, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const update = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`restaurant/v2/restaurants/categories`, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const deleteCategory = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.delete(`restaurant/v2/restaurants/categories/${id}`).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const updateStatus = (id, status) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`restaurant/v2/restaurants/categories/${id}/status/${status}`).then(resolve, reject);
	});
};

const addRestaurant = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`restaurant/v2/restaurants/categories/relations`, payload).then(resolve, reject);
	});
};

const removeRestaurant = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.delete(`restaurant/v2/restaurants/categories/relations/${id}`).then(resolve, reject);
	});
};

const menuCategories = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`/businesses/v1/businesses/menu_categories?${query}`).then(({ data }) => {
			resolve(prepAutocompleteData(data.data, 'categoryName', 'id'));
		}, reject);
	});
};

const createOrUpdateMenuCategory = (payload) => {
	return new Promise((resolve, reject) => {
		let endpoint, httpVerb;
		if (payload.id) {
			httpVerb = 'put';
			endpoint = `businesses/v1/businesses/menu_categories/${payload.id}`;
		} else {
			httpVerb = 'post';
			endpoint = `businesses/v1/businesses/menu_categories`;
		}
		ApiFactory[httpVerb](endpoint, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const toggleStatus = (category) => {
	return new Promise((resolve, reject) => {
		const endpoint = `/businesses/v1/businesses/menu_categories/${category.id}/status/${category.status ? 0 : 1}`;
		ApiFactory.put(endpoint).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const getBlockTypes = () => {
	return new Promise((resolve, reject) => {
		const endpoint = `/marketing/v1/app/blocks/options/types`;
		ApiFactory.get(endpoint).then(({ data }) => {
			resolve(prepAutocompleteData(data.data, 'value', 'id'));
		}, reject);
	});
};

export default {
	get,
	details,
	create,
	update,
	delete: deleteCategory,
	updateStatus,
	addRestaurant,
	removeRestaurant,
	menuCategories,
	createOrUpdateMenuCategory,
	toggleStatus,
	getBlockTypes,
};
